import { Field, Int, ObjectType } from '@nestjs/graphql'
import { BaseModelWithoutUserDto } from './baseModelWithoutUser.dto'

@ObjectType()
export class BaseModelDto extends BaseModelWithoutUserDto {
  @Field(type => Int)
  userId!: number
}
